module.exports = __webpack_public_path__ + "img/badge_gray_pop-foundation.466b791f.svg";